module.exports = __webpack_public_path__ + "img/alexa-icon.45912583.svg";